import { ProductRepository } from '../repositories/ProductRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class ProductRatingSelectedUseCase {
    private productId: string;
    private selectedIndex: number;
    private productRepository: ProductRepository;

    constructor(productId: string, selectedIndex: number) {
        this.productId = productId;
        this.selectedIndex = selectedIndex;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = () => {
        if (this.productId) {
            const product = this.productRepository.products.find(
                prod => prod.productId === this.productId
            );

            if (product) {
                product.reviews.setRating(this.selectedIndex);
            }
        }
    };
}
